import { SITE_URL } from "../../../../../company/settings/metadata";
import { cleanSlashInPath } from "./cleanSplash";

export function getAbsoluteUrl(path: string, siteUrl?: string): string {
  const pathClean = cleanSlashInPath(path);
  try {
    new URL(pathClean);
    return new URL(pathClean).href;
  } catch (e) {
    return cleanSlashInPath(`${new URL(pathClean, siteUrl || SITE_URL).href}`);
  }
}
